module.exports = "/images/02.svg?c6575f7457bb7192bf6c7a4feb275050";